import styled from 'styled-components'

export const Container = styled.div`
  padding: 1rem;
  max-width: 1300px;
  margin: 0 auto;
`

export const Search = styled.div`
  background: ${({ theme }) => `rgba(${theme.grayscale[400]}, 0.3)`};
  border-radius: 4px;
  width: 100%;
  margin: 2rem auto 2rem 0;
  padding: 1rem;
  display: flex;
  align-items: center;
  max-width: 870px;

  svg {
    height: 1rem;
    margin-right: 0.5rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }

  input {
    border: none;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    width: 100%;
    font-size: 0.833rem;
    font-family: Montserrat;
    font-weight: 500;

    &::placeholder {
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    }
  }
`
